import { Box, Heading } from "@vinomofo/components";
import { useState } from "react";

import { Button } from "../../button";
import { InstantSearchProvider } from "../../instant-search/InstantSearchProvider";
import { ProductCollection } from "../../product-collection";
import { isWhiskymofo } from "../../../utils/is-page";

interface CollectionProps {
  collectionLink?: string;
  navigationName: string;
  name?: string;
  productFilter?: {
    filters: string;
  };
}

export interface FeaturedProductCollectionsProps {
  title: string;
  includeAllWinesLink?: boolean;
  collections: Array<CollectionProps>;
}

export const FeaturedProductCollections = ({
  title,
  includeAllWinesLink = false,
  collections,
}: FeaturedProductCollectionsProps): JSX.Element => {
  const [activeCollection, setActiveCollection] = useState<CollectionProps>(
    collections[0]
  );

  const collectionProps = {
    limit: 4,
    filters: activeCollection?.productFilter?.filters,
    columns: 4,
  };

  const viewAllLink = isWhiskymofo ? "/spirits" : "/wines";
  const viewAllText = isWhiskymofo ? "View all spirits" : "View all wines";

  return (
    <InstantSearchProvider isFeatured>
      <Box>
        <Box display="flex" alignItems="center" mb={40}>
          <Box flexShrink={0}>
            <Heading color="brand" variant="xxl">
              {title}
            </Heading>
          </Box>
          <Box
            display="flex"
            ml={"30px"}
            position={"relative"}
            top={"5px"}
            justifyContent={"space-around"}
            flexGrow={1}
            overflow={["scroll", "auto"]}
          >
            {collections.map((collection, i) => (
              <Box flexShrink={0} key={i}>
                <Button
                  ghost={activeCollection !== collections[i]}
                  outline
                  onClick={() => setActiveCollection(collections[i])}
                  color={
                    activeCollection === collections[i] ? "brand" : "black"
                  }
                  hoverColor="white"
                  fontWeight={700}
                  fontFamily={"Graphik"}
                >
                  {collection.navigationName || collection.name}
                </Button>
              </Box>
            ))}
            {includeAllWinesLink && (
              <Box flexShrink={0}>
                <Button
                  as={Box}
                  ghost
                  color="black"
                  to={viewAllLink}
                  fontWeight={700}
                >
                  {viewAllText}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
        {activeCollection && (
          <ProductCollection
            {...collectionProps}
            showMoreLink={activeCollection?.collectionLink}
          />
        )}
      </Box>
    </InstantSearchProvider>
  );
};
